import { render, staticRenderFns } from "./SoftwareMetadata.vue?vue&type=template&id=b31d44ec&"
import script from "./SoftwareMetadata.vue?vue&type=script&lang=ts&"
export * from "./SoftwareMetadata.vue?vue&type=script&lang=ts&"
import style0 from "./SoftwareMetadata.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports